import React from "react";
import { I18n } from "../../../../models/I18n";
import { Participant } from "../../../../models/Participant";
import EditableText from "../../../EditableText/EditableText";
import style from "./style/Reflection.module.scss";

export interface ReflectionProps {
    participant: Participant;
    title: string;
    text: string;
    editable: boolean;
    textSaveInterval?: number;
    submitReflectionText?: (data: { value: string }) => void;
    i18n: I18n;
}

const Reflection = ({
    participant,
    title,
    text,
    editable,
    textSaveInterval,
    submitReflectionText,
    i18n
}: ReflectionProps) => {
    const createDOMPurify = require("isomorphic-dompurify");
    const DOMPurify = createDOMPurify(window);

    const getParticipantName = ({ firstName, infix, lastName }: Participant) => {
        return infix ? `${firstName} ${infix} ${lastName}` : `${firstName} ${lastName}`;
    };

    const getParticipantNameWithInitials = ({ firstName, infix, lastName }: Participant) => {
        return `${firstName[0].toUpperCase()}. ${infix ? `${infix} ` : ""}${lastName}`;
    }

    const placeholder = editable
        ? i18n.report_management_summary_reflection_placeholder
        : i18n.report_management_summary_reflection_placeholder_client;

    const handleSave = (text: string) => {
        submitReflectionText({ value: text });
    }

    return (
        <div className={style.reflectionWrapper}>
            <h4>{`${title} ${i18n.report_management_summary_reflection_by} ${getParticipantName(participant)}`}</h4>
            <p>{`${i18n.report_management_summary_reflection_written_by} ${getParticipantNameWithInitials(participant)}`}</p>
            {editable
                ? <EditableText
                    saveInterval={textSaveInterval}
                    placeholder={placeholder}
                    classes={{ textPresentation: `${style.readOnly} ${!text ? style.empty : ""}`  }}
                    text={text}
                    handleSave={handleSave}
                    showSaveButton={true}
                />
                : <div
                    className={`${style.readOnly} ${!text ? style.empty : ""}`}
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text || placeholder)}}
                    data-testid="reflection-text"
                />}
        </div>
    );
};

export default Reflection;
